<app-modal
  [isVisible]="isVisible()"
  [config]="modalConfig"
  [primaryButtonDisabled]="!hasChanges() || isSaving()"
  [primaryButtonLoading]="isSaving()"
  (confirmed)="onSave()"
  (cancelled)="onCancel()"
  (secondary)="onCancel()"
  (closed)="onClose()"
>
  <div class="prompt-modal-content">
    <!-- Header Information -->
    <div class="prompt-header-info">
      <div class="content-type-section">
        <h3 class="content-type-title">{{ contentTypeDisplay() }}</h3>
        <p class="content-type-description">
          Prompt for generating {{ contentTypeDisplay().toLowerCase() }} content
        </p>
      </div>

      @if (prompt(); as p) {
        @if (!isLoading() && !error()) {
          <div class="prompt-metadata">
            <span class="metadata-item">
              <span class="metadata-label">Created:</span>
              <span class="metadata-value">{{ p.created_at | date: 'short' }}</span>
            </span>
            <span class="metadata-item">
              <span class="metadata-label">Updated:</span>
              <span class="metadata-value">{{ p.updated_at | date: 'short' }}</span>
            </span>
          </div>
        }
      }
    </div>

    <!-- Loading State -->
    @if (isLoading()) {
      <app-skeleton type="details" [count]="3" />
    }

    <!-- Error State -->
    @if (error(); as err) {
      <div class="error-state">
        <p class="error-message">{{ err }}</p>
        <button class="retry-button" (click)="loadPrompt()">Retry</button>
      </div>
    }

    <!-- Prompt Content -->
    @if (!isLoading() && !error() && prompt()) {
      <div class="prompt-content">
        <div class="field prompt-field">
          <label for="prompt-text">Prompt Text</label>
          <textarea
            id="prompt-text"
            [value]="promptText()"
            (input)="onPromptTextChange($event)"
            placeholder="Enter your prompt text here..."
            rows="15"
          ></textarea>
          <small>
            This prompt will be used to generate content for {{ contentTypeDisplay() }} documents.
          </small>
        </div>
      </div>
    }
  </div>
</app-modal>
